import { ReduxHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";

export const prefix = "APP";
export const showAlert = ReduxHelper.generateLocalAction<{
  message: string;
  type: EAlertType;
}>(prefix, "SHOW_ALERT");
export const closeAlert = ReduxHelper.generateLocalAction(
  prefix,
  "CLOSE_ALERT"
);
